import React, { Component, useState } from 'react'

import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios'
import { getUser, useLastPage, useTitleFunctional } from '../functions/Reusables';
import { useLocation, useNavigate } from 'react-router-dom';

export default function CreateProsecuted(){

  const location = useLocation();
  let navigate = useNavigate();

  const [status, setStatus] = useState("Completed"); 
  const [comment, setComment] = useState(""); 
  const [successMessage, setSuccessMessage] = useState(""); 
  const [errorMessage, setErrorMessage] = useState(""); 
  const [isLoading, setIsLoading] = useState(false); 



  function isEmpty(str) {
    return !str.trim().length;
  }

 async function  createProsecuted(){
  if(isEmpty(comment)){
    setErrorMessage("All Fields are required")
  }else{

    setIsLoading(true)
      const createRequest = {
        "pid": (parseInt(location.state.pid.slice(3))).toString(),
        "status": status,
        "legal": getUser().user_id,
        "comment": comment
      };
      const headers = {
        "AccessToken": getUser().access_token
      }
      try {
        console.log(createRequest)
        const response = await axios.post(
          `${process.env.REACT_APP_API}legal/create_pros/`,
          createRequest,
          {headers}
        );
          setSuccessMessage("Prosecuted Added Successfully")
          setIsLoading(false)
        
      } catch (error) {
        const errors = []
        console.log(error)
        setErrorMessage("Something went wrong")
        
        if(error.response !== null || error.response !== undefined){
          setErrorMessage(error.response.data.message)
        }
        setIsLoading(false)
      }

  }
 }

 useTitleFunctional("Create Prosecuted | AMAC Tenement")
 useLastPage("createprosecuted")
    return (
          <div className="page-body">
             { isLoading ? <div class="loader-wrapper" style={{background:'#fff'}}>
            <div class="theme-loader"> 
            <img style={{position: 'absolute',top: 'calc(50vh + 80px)', left: 'calc(50vw - 48px)'}} className="img-fluid" src="assets/images/logo/logo2.png" alt=""/>  
              <div class="loader-p"></div>
              <p style={{position: 'absolute',top: 'calc(50vh + 110px)', left: 'calc(50vw - 24px)',  fontSize:'12px'}}>LOADING</p>
            </div>
          </div> : <div></div>}
          <div className="container-fluid" >
            <div className="page-header">
              <div className="row" style={{display:'flex'}}>
                <div className="col" >
                  <h3>Create Prosecuted</h3>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="#" onClick={()=>navigate("/prosecuted")}>Prosecuted</a></li>
                    <li className="breadcrumb-item">Create Prosecuted</li>
                  </ol>
                </div>
                <div className="col" style={{display:'flex', justifyContent:'end'}}>

                </div>
              </div>
            </div>
          </div>
          
          <div className="container-fluid" style={{marginTop:'20px'}}>
            <div className="row">
            <div className="card">
           
                  <div className="card-header pb-0">
                    {/* <h5>Change Password</h5> */}
                  </div>
                  <div className="form theme-form">
                  {errorMessage!== "" ? 
                  <div className="alert alert-danger dark alert-dismissible fade show" role="alert"><strong>{errorMessage}</strong>
                    <button class="btn-close" onClick={()=>{
                     setErrorMessage("")
                    }} type="button"  aria-label="Close" data-bs-original-title="" title=""></button>
                  </div>
                  : <div></div>
                  }
                    {successMessage !== "" ?<div class="alert alert-primary dark alert-dismissible fade show" style={{backgroundColor:'#51cd51', borderColor:'#51cd51'}} role="alert"><strong>{successMessage}</strong>
                      <button className="btn-close" onClick={()=>{
                        setSuccessMessage("")
                      }} type="button"  aria-label="Close" data-bs-original-title="" title=""></button>
                    </div>: <div></div>}
                    <div className="card-body">
                      <div className="row">
                        <div className="col">
                          {/* <div className="mb-3 row">
                            <label className="col-sm-3 col-form-label" >Old Password</label>
                            <div className="col-sm-9">
                              <input className="form-control" type="password" placeholder="Type your Old Password"/>
                            </div>
                          </div> */}
                          <div className="mb-3 row">
                            <label className="col-sm-3 col-form-label">PID</label>
                            <div className="col-sm-9">
                              <input className="form-control" disabled value={location.state.pid} type="text" placeholder="PID"/>
                            </div>
                          </div>
                       
                         
                          
                          <div className="mb-3 row">
                            <label className="col-sm-3 col-form-label">Role</label>
                            <div className="col-sm-9">
                            <select class="form-select digits" value={status} id="exampleFormControlSelect9" onChange={(e)=>{
                                        setStatus(e.target.value)
                                      }}>
                                        
                                  <option value="Completed" >Completed</option>
                                  <option value="Ongoing" >Ongoing</option>
                                       
                                        
                                    </select>
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="col-sm-3 col-form-label">Comment</label>
                            <div className="col-sm-9">
                              <textarea className="form-control" value={comment} onChange={(e)=>{
                                setComment(e.target.value)
                              }} type="text" placeholder="Add Comment"></textarea>
                            </div>
                          </div>
                          
                          
                        </div>
                      </div>
                    </div>
                    <div className="card-footer text-end">
                      <div className="col-sm-9 offset-sm-3">
                        <button className="btn btn-primary" onClick={()=>{
                          createProsecuted()
                        }} type="submit">Submit</button>
                        
                      </div>
                    </div>
                  </div>
                </div> 
            </div>
          </div>
        </div>
    )

}
